module.exports = [
	{
		"value": "01",
		"label": "the West"
	},
	{
		"value": "02",
		"label": "the Midwest"
	},
	{
		"value": "03",
		"label": "the Southwest"
	},
	{
		"value": "04",
		"label": "the Southeast"
	},
	{
		"value": "05",
		"label": "the Northeast"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assess/question/regions.json
// module id = 194
// module chunks = 0